// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"89":"78c06aa9","238":"501d8cf4","453":"d275ea9a"}[chunkId] + ".chunk.js";
};